import { Component, Input } from '@angular/core';
import { StudentStatusId } from '../../models/HealthMinistry';

@Component({
    selector: 'app-health-ministry-resident-status',
    template: `
    <span *ngIf="name" class="badge"
        [class.text-bg-success]="id == status.Active"
        [class.text-bg-danger]="id == status.Expelled"
        [class.text-bg-warning]="id == status.AcademicLeave"
        [class.text-bg-dark]="id == status.Exmatriculated"
        [class.text-bg-primary]="id == status.ScientificDegreeCandidate"
        [class.text-bg-secondary]="id == status.ExchangeProgram"
        [class.text-bg-info]="id == status.DoctoralDegree">
    {{name}}</span>
`
})
export class HealthMinistryResidentStatusComponent {
    @Input() id: number;
    @Input() name: string;

    readonly status = StudentStatusId;
}
